export * from './named-icons'
export type {
  IconSizeType,
  IconBaseProps,
  IconProps,
  IconComponentType,
  NamedIconPropsType,
  NamedIconComponentType,
} from './types'
export { IconSize } from './types'
export { default as Icon } from './Icon'
